import FunctionalButton from "components/layout/FunctionalButton";

import { ReactComponent as CloseIcon } from "assets/svgs/Close.svg";

const CloseButton = ({ className = "", onClick = () => {} }) => {
    return <FunctionalButton className={className} icon={<CloseIcon />} onClick={onClick} />;
};

export default CloseButton;
